import { getTime } from "../utils/time";

const DateTimeItem = ({
  time,
  "data-test-id": dataTestId,
}: {
  time: number;
  "data-test-id"?: string;
}): JSX.Element => (
  <p className="shrink-0 mb-2 tablet:mb-0 text-sm" data-test-id={dataTestId}>
    {getTime(time)}
  </p>
);

export default DateTimeItem;
